import { contractGenerateContractContractSelector } from "common/_redux/contract/selector";
import { useAppSelector } from "core/store/hooks";
import { loader } from "core/store/selectors";
import { layoutCurrentPraticaStateSelector } from "layout/_redux/selectors";
import React from "react";
import { Spinner } from "react-bootstrap";

interface Props {
	type?: string;
}

const Loader: React.FC<Props> = ({ type }) => {
	const loaderSelector = useAppSelector(loader(type));
	const currentPraticaState = useAppSelector(layoutCurrentPraticaStateSelector);
	const detailsGenerateContract = useAppSelector(contractGenerateContractContractSelector);
	const isStep7 = currentPraticaState?.some((step) => step.route === "/step-7");

	if (loaderSelector) {
		return (
			<div className="loader-container">
				{isStep7 && !detailsGenerateContract ? (
					<div className="bg-white d-flex justify-content-center align-items-center flex-column p-3 rounded-3">
						<Spinner className="loader" animation="border" />
						<div className="flex-row">
							<h5 className="mt-3 mb-2">
								<i className="fa-solid fa-pen-to-square me-2"></i>Stiamo compilando il tuo contratto
							</h5>
						</div>
					</div>
				) : (
					<Spinner className="loader" animation="border" />
				)}
			</div>
		);
	} else {
		return null;
	}
};

export default Loader;
